import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Metadata\GetAllCorporationController::__invoke
* @see app/Http/Controllers/Metadata/GetAllCorporationController.php
* @route '/api/metadata/all-corporation'
*/
const GetAllCorporationController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAllCorporationController.url(options),
    method: 'get',
})

GetAllCorporationController.definition = {
    methods: ["get","head"],
    url: '/api/metadata/all-corporation',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Metadata\GetAllCorporationController::__invoke
* @see app/Http/Controllers/Metadata/GetAllCorporationController.php
* @route '/api/metadata/all-corporation'
*/
GetAllCorporationController.url = (options?: RouteQueryOptions) => {
    return GetAllCorporationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Metadata\GetAllCorporationController::__invoke
* @see app/Http/Controllers/Metadata/GetAllCorporationController.php
* @route '/api/metadata/all-corporation'
*/
GetAllCorporationController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAllCorporationController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Metadata\GetAllCorporationController::__invoke
* @see app/Http/Controllers/Metadata/GetAllCorporationController.php
* @route '/api/metadata/all-corporation'
*/
GetAllCorporationController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAllCorporationController.url(options),
    method: 'head',
})

export default GetAllCorporationController